import React from 'react';
import './circleviewcta.css'
import arrow from '../../assets/pic15.png'

const CircleCta = () => {
    return ( 
        <button className='circle-cta'>
            <img className='arrroww' src={arrow} alt='view'></img>
        </button>
     );
}
 
export default CircleCta;